<template src="../templates/normal_fcont_176.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import DesignPaperTiles from '../components/DesignPaperTiles'
import DesignPaperTilesNonMessage from '../components/DesignPaperTilesNonMessage'
import PrintButton from '../components/PrintButton'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '176',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,
    DesignPaperTiles,DesignPaperTilesNonMessage,PrintButton,ReleaseDateForArticle,InfoMachineTranslation
  },
  methods: {
    clickInternalLink: function (linkName) {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "internal_link",
        "custom_parameter2": linkName
      })
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['176-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['176-3']}
      ]
    };
  }
  
};
</script>
<style scoped>
h4.left_indent_caption {
  margin-top: 30px;
  margin-bottom: 0px;
  padding-left: 14px;
}
p.design_category{
  margin-left: 15px;
  margin-bottom: 0px;
}
div.creator_profileanddesign{
  margin-bottom: 20px;
}
</style>

